module.exports = __webpack_public_path__ + "static/media/changeUser.febdb81b.svg";